
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Classical And Semi <span > Classical Vocal</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-7">
                <div class=" text-justify">
                    <h2 class="head-lea">URVASHI SHAH <span class="small-sm"> 20 OCTOBER 2019</span></h2>
                    <p>Urvashi Shah realized that music is her true calling very early in life. To give her musical
                        leanings a tangible form, she spent 7 years learning under the tutelage of Mrs. Meera Banerjee
                        of the Patiala Gharana, in Kolkata.</p>
                    <p>Having relocated to Pune in 1998, she continued her pursuit for excellence in Indian Classical
                        singing by learning under the guidance of Dr. Veena Sahastrabuddhe of the Gwalior Gharana from
                        1999 till 2014.</p>

                </div>
            </div>
            <div class="col-md-5">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/UrvashiShah.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <p>Urvashi also gained invaluable insights into music from Pandit Mohan Karve of the Gwalior Gharana, under
                whose tutelage she learnt from 2001 to 2005.</p>
            <p>A much sought-after classical singer in Pune today, Urvashi also holds a BA in Political Science from St.
                Xavier's College, Kolkata. She then attained a Sangeet Visharad and Sangeet Alankar from the Gandharva
                Mahavidyalaya, Meeraj.</p>
        </div>

        <div class="border-line-sm"></div>

        <div class="row">
            <div class="col-lg-9">
                <h6 class="fw-bold">Let’s meet you then.</h6>
                <p> Topic: Classical and Semi Classical Vocal</p>
                <p>Date: Sunday, 20 <sup>th</sup> October 2019</p>
                <p>Time: 6.45 PM</p>
                <p>Venue: Hamsa Hall Soham- Beside Seva Sadan Saksham High School, Sitabuldi, Nagpur- 440010</p>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <h6 class="fw-bold"> INVITATION</h6>
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/UrvashiShah-Invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">MEDIA COVERAGE</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">VIDEOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230"
                    src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F591443561498686%2F&show_text=false&width=560&t=0"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">PHOTOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-2">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
